import MetadataConfirmation from './MetadataConfirmation'
import ParsingOptions from './ParsingOptions'

/**
 * Router component to show correct step input form
 * Maps step number to appropriate component
 */
const STEP_COMPONENTS = {
  2: MetadataConfirmation, // Step 2: Confirm metadata
  3: ParsingOptions, // Step 3: Parsing options (FEATURE-010)
}

/**
 * Step Input Router for Synchro workflow
 * @param {Object} analysis - Full analysis object
 * @param {Object} step - Current step object
 * @param {Function} onSubmit - Submit callback
 * @param {boolean} loading - Loading state
 */
function StepInputRouter({ analysis, step, onSubmit, loading = false }) {
  const Component = STEP_COMPONENTS[step.step_number]

  if (!Component) {
    return (
      <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
        <p className="text-sm text-yellow-800">
          No input form configured for step {step.step_number}.
        </p>
      </div>
    )
  }

  // Configuration steps need to display the previous step's output_data
  // Step 2 (Metadata Confirmation) displays Step 1's parsed metadata
  const previousStep = analysis.steps?.find((s) => s.step_number === step.step_number - 1)

  // Merge current step with previous step's output data for configuration steps
  const enrichedStep = {
    ...step,
    output_data: previousStep?.output_data || step.output_data || {},
  }

  return <Component analysis={analysis} step={enrichedStep} onSubmit={onSubmit} loading={loading} />
}

export default StepInputRouter
